import * as actionTypes from "../actionTypes/Index";
import { categoryGlobalInitialState } from "./InitialState";
import { IActionType } from "../../interfaces/Index";

const initialState = { ...categoryGlobalInitialState };

export const appendUpdateCategories = (payload: any, state: any) => {
  if (payload.isPaginatedRes) {
    return [...state.categoriesGlobal, ...payload.categoriesGlobalData];
  }
  return payload.categoriesGlobalData.slice();
};

export default function categoryGlobalReducer(
  state = initialState,
  action: IActionType
) {
  switch (action.type) {
    case actionTypes.CREATE_CATEGORY_GLOBAL_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isCategoryGlobalAdded: false,
        isCoreCategoriesGlobalFetched: false,
        error: null,
      });
    }
    case actionTypes.CREATE_CATEGORY_GLOBAL_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isCategoryGlobalAdded: true,
      });
    }
    case actionTypes.CREATE_CATEGORY_GLOBAL_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isCategoryGlobalAdded: false,
        error: action.error,
      });
    }
    case actionTypes.GET_CATEGORIES_GLOBAL_LIST_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isFetchCategoryGlobalLoading: true,
        isFetchCategoryGlobalError: false,
        isCategoryGlobalAdded: false,
        isCategoryGlobalUpdated: false,
        error: null,
        isError: false,
      });
    }
    case actionTypes.GET_CATEGORIES_GLOBAL_LIST_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isFetchCategoryGlobalLoading: false,
        categoriesGlobal: appendUpdateCategories(action.payload, state),
        pagination: (action.payload! as any).pagination,
      });
    }
    case actionTypes.GET_CATEGORIES_GLOBAL_LIST_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isFetchCategoryGlobalLoading: false,
        isFetchCategoryGlobalError: true,
        error: action.error,
      });
    }
    case actionTypes.UPDATE_CATEGORY_GLOBAL_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isCategoryGlobalUpdated: false,
        error: null,
        isCategoryGlobalAdded: false,
      });
    }
    case actionTypes.UPDATE_CATEGORY_GLOBAL_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isCategoryGlobalUpdated: true,
        coreCategories: [],
        isCoreCategoriesGlobalFetched: false,
      });
    }
    case actionTypes.UPDATE_CATEGORY_GLOBAL_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isCategoryGlobalUpdated: false,
        error: action.error,
      });
    }
    case actionTypes.GET_CORE_CATEGORIES_GLOBAL_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isCoreCategoriesGlobalFetched: false,
        coreCategories: [],
        error: null,
      });
    }
    case actionTypes.GET_CORE_CATEGORIES_GLOBAL_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        isCoreCategoriesGlobalFetched: true,
        coreCategories: (action.payload! as Array<any>).slice(),
      });
    }
    case actionTypes.GET_CORE_CATEGORIES_GLOBAL_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isCoreCategoriesGlobalFetched: false,
        error: action.error,
      });
    }
    default:
      return state;
  }
}
